import { render, staticRenderFns } from "./myDetail.vue?vue&type=template&id=c4ace72e&scoped=true&"
import script from "./myDetail.vue?vue&type=script&lang=js&"
export * from "./myDetail.vue?vue&type=script&lang=js&"
import style0 from "./myDetail.vue?vue&type=style&index=0&id=c4ace72e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ace72e",
  null
  
)

export default component.exports